import React from 'react';

export default class EpubValidatorResults extends React.PureComponent {
  render() {
    return (<div className="epub-val-results">
      <div className="epub-val">
        <div className="epub-val-icon">
          {this.props.icon}
        </div>
        <div className="epub-val-head">
          {this.props.text}
        </div>
      </div>
      {this.props.children}
    </div>);
  }
}
